import { MainContainer, HealthCheckList, HelperWrapper } from 'src/components'

import { joinAbsRoute } from 'src/common/utils'
import { ROUTES } from 'src/constants'
import { ETranslationNs } from 'src/types'

const HealthCheckInternalScreen = () => {
  return (
    <MainContainer
      headerTitle={<HelperWrapper t="third-party-api-header-title" ns={ETranslationNs.Navbar} />}
      navigateBack
      navigateBackRoute={joinAbsRoute(ROUTES.ADMIN_ROUTES)}
    >
      <HealthCheckList />
    </MainContainer>
  )
}

export default HealthCheckInternalScreen
